// Note: extra types in `index.d.ts`.
export {
  gfmStrikethroughFromMarkdown,
  gfmStrikethroughToMarkdown
} from './lib/index.js'
